import React from 'react';
import { Modal, Backdrop, Fade, Box, Grid, Paper, Typography } from '@mui/material';

const ImageModal = ({ open, onClose, imagePreviews, fileInfo }) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 500 }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '60%',
                        maxHeight: '80vh',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        overflowY: 'auto'
                    }}
                >
                    <Grid container spacing={2}>
                        {imagePreviews.map((img, index) => (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                <Paper
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '100%',
                                        p: 2
                                    }}
                                >
                                    <img 
                                        src={img} 
                                        alt={`img-${index}`} 
                                        style={{ maxWidth: '80%', height: 'auto' }} 
                                    />
                                    <Typography align="center" sx={{ mt: 1 }}>
                                        {fileInfo[index]?.name} ({fileInfo[index]?.size})
                                    </Typography>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Fade>
        </Modal>
    );
};

export default ImageModal;
